import React from "react";
import CameraCapture from "./CameraCapture";
import ImageList from "./ImageList";
import AnnotationEditor from "./AnnotationEditor";

const ImageAnnotator = ({
  showCamera,
  images,
  handleCapture,
  selectedImage,
  handleImageSelect,
  handleDeleteImage,
  annotations,
  annotation,
  handleAnnotationChange,
  handleAnnotationSubmit,
  options
}) => {
  return (
    <div className="image-annotator">
      {showCamera && (
        <div className="row mb-4">
          <div className="col">
            <CameraCapture onCapture={handleCapture} />
          </div>
        </div>
      )}

      {images.length > 0 && (
        <div className="row">
          <div className="col-md-4">
            <ImageList
              images={images}
              selectedImage={selectedImage}
              onSelectImage={handleImageSelect}
              onDeleteImage={handleDeleteImage}
            />
          </div>
          <div className="col-md-8">
            <AnnotationEditor
              image={images[selectedImage]}
              annotations={annotations[selectedImage] || []}
              value={annotation}
              onChange={handleAnnotationChange}
              onSubmit={handleAnnotationSubmit}
              options={options}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageAnnotator;
